var _circle, _circle2, _circle3, _circle4, _circle5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "dots_svg__lds-ellipsis",
    style: {
      background: "0 0"
    }
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 50,
    r: 0,
    fill: "#71c2cc"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "10;0;0;0;0",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "84;84;84;84;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "0s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.999,
    cy: 50,
    r: 10,
    fill: "#5c6881"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;10;10;10;0",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "-0.9s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "16;16;50;84;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "-0.9s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 50,
    r: 10,
    fill: "#ec808a"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;10;10;10;0",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "-0.45s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "16;16;50;84;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "-0.45s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 50,
    r: 0,
    fill: "#7678ac"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;10;10;10;0",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "16;16;50;84;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "0s"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.999,
    cy: 50,
    r: 10,
    fill: "#71c2cc"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "0s"
  }))));
}

export default SvgDots;